export default "__VITE_ASSET__txN2qtI$__"